import { Image, Typography, Button, Modal } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import "./GalerijaSlikaClanka.css";

const { Title } = Typography;

const GalerijaSlikaClanka = ({ galerija }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  useEffect(() => {
    const updateItemsPerPage = () => {
      if (window.innerWidth < 480) {
        setItemsPerPage(2);
      } else if (window.innerWidth < 768) {
        setItemsPerPage(3);
      } else if (window.innerWidth < 1025) {
        setItemsPerPage(4);
      } else {
        setItemsPerPage(5);
      }
    };

    updateItemsPerPage();
    window.addEventListener("resize", updateItemsPerPage);
    return () => window.removeEventListener("resize", updateItemsPerPage);
  }, []);

  const totalPages = Math.ceil(galerija.length / itemsPerPage);

  const handlePrev = () => {
    if (currentPage > 0) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages - 1) setCurrentPage(currentPage + 1);
  };

  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  const handleModalClose = () => {
    setSelectedImageIndex(null);
  };

  const visibleImages = galerija.slice(
    currentPage * itemsPerPage,
    currentPage * itemsPerPage + itemsPerPage
  );

  return (
    <>
      {galerija.length > 0 && (
        <div className="galerija-clanka-container">
          <Title level={4} className="galerija-clanka-title">
            Galerija slika
          </Title>

      

          <div className="galerija-clanka-wrapper">
            <Button
              icon={<LeftOutlined />}
              onClick={handlePrev}
              disabled={currentPage === 0}
              className="galerija-clanka-button"
            />

            {visibleImages.map((slika, idx) => (
              <Image
                key={slika.id}
                src={slika.putanja}
                alt="Galerijska slika"
                width={'auto'}
                height={'auto'} 
                preview={false}
                onClick={() =>
                  handleImageClick(currentPage * itemsPerPage + idx)
                }
                className="galerija-clanka-image"
                fallback="https://via.placeholder.com/150"
              />
            ))}

            <Button
              icon={<RightOutlined />}
              onClick={handleNext}
              disabled={currentPage === totalPages - 1}
              className="galerija-clanka-button"
            />
          </div>
        </div>
      )}

      {selectedImageIndex !== null && (
        <Modal
          open={true}
          footer={null}
          onCancel={handleModalClose}
          centered
          width={800}
        >
          <div className="modal-content-clanka">
            <Image
              src={galerija[selectedImageIndex].putanja}
              alt="Pregled slike"
              className="modal-image-clanka"
              fallback="https://via.placeholder.com/600x400"
            />
            <div>
              <Button
                icon={<LeftOutlined />}
                onClick={() =>
                  setSelectedImageIndex((prev) => (prev > 0 ? prev - 1 : prev))
                }
                disabled={selectedImageIndex === 0}
                className="modal-button-clanka"
              />
              <Button
                icon={<RightOutlined />}
                onClick={() =>
                  setSelectedImageIndex((prev) =>
                    prev < galerija.length - 1 ? prev + 1 : prev
                  )
                }
                disabled={selectedImageIndex === galerija.length - 1}
                className="modal-button-clanka"
              />
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default GalerijaSlikaClanka;
